module.exports = __webpack_public_path__ + "img/Indonesia-4.7d75357f.jpg";